<template>
  <BCard>
    <div class="flex flex-col gap-3">
      <div class="flex flex-row items-center justify-between">
        <div class="flex">
          <BButton
            variant="primary"
            size="sm"
            class="mr-1 rounded-lg p-0"
            @click="$router.go(-1)"
          >
            <feather-icon
              size="2x"
              icon="ChevronLeftIcon"
            />
          </BButton>
          <strong class="text-black text-2xl">Bayar</strong>
        </div>
        <div
          class="text-black p-[5px] rounded-md flex items-center gap-2 bg-[#fef2cd]"
        >
          <span>Kompoints:</span>
          <img
            class="w-6"
            src="https://storage.googleapis.com/komerce/assets/icons/Kompoints.svg"
            alt="kompoint"
          >
          <strong class="text-black">{{
            IDRWithoutLbl(kompoints.balance)
          }}</strong>
        </div>
      </div>
      <BRow class="p-1">
        <BCol
          cols="12"
          class="border rounded-lg p-1 mb-2"
        >
          <BCard
            class="m-0"
            body-class="p-0"
          >
            <div
              class="flex flex-col sm:flex-row justify-between p-0 gap-3 sm:gap-0"
            >
              <div class="flex flex-col">
                <div class="flex flex-row items-center gap-3">
                  <div class="w-[36px] h-[36px] rounded-lg flex items-center justify-center bg-[linear-gradient(225deg,_#96E1E9_0%,_#09D6FE_100%)]">
                    <img
                      src="https://storage.googleapis.com/komerce/komed/komed-logo-white.svg"
                      alt="KOMED"
                      width="28"
                      height="28"
                    >
                  </div>
                  <div class="text-black font-medium text-lg">
                    Kredit Komed
                  </div>
                  <img
                    id="kreditKomedTooltip"
                    class="align-self-center"
                    src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                  >
                  <b-popover
                    triggers="hover"
                    target="kreditKomedTooltip"
                    placement="topRight"
                  >Kredit Komed digunakan untuk generate video UGC AI</b-popover>
                </div>
                <span class="text-black mt-[5px]">
                  Top Up kredit Komed sekarang juga menggunakan Kompay.
                </span>
              </div>
              <div class="items-center flex">
                <BButton
                  :variant="canTopupKomed ? 'primary' : 'outline-secondary'"
                  size="sm"
                  class="rounded-lg px-1 w-full sm:w-auto"
                  :disabled="!canTopupKomed"
                  @click="openKreditKomedTopUp"
                >
                  <div class="flex items-center justify-center gap-3">
                    <img
                      :src="
                        canTopupKomed
                          ? 'https://storage.googleapis.com/komerce/assets/icons/send-square.svg'
                          : 'https://storage.googleapis.com/komerce/assets/icons/send-square-gray.svg'
                      "
                      alt="send"
                      width="24"
                      height="24"
                    >
                    <span>
                      Top Up
                    </span>
                  </div>
                </BButton>
              </div>
            </div>
          </BCard>
        </BCol>
        <BCol
          cols="12"
          class="border rounded-lg p-1 mb-2"
        >
          <BCard
            class="m-0"
            body-class="p-0"
          >
            <div
              class="flex flex-col sm:flex-row justify-between p-0 gap-3 sm:gap-0"
            >
              <div class="flex flex-col">
                <div class="flex flex-row gap-3">
                  <img
                    src="https://storage.googleapis.com/komerce/assets/logo/logo-only/Logo-Komads.svg"
                    alt="KOMADS"
                    width="32"
                    height="32"
                  >
                  <div class="text-black font-medium text-lg">
                    Komads Whitelisted
                  </div>
                </div>
                <span class="text-black">
                  Top up akun Whitelisted pakai Kompay sekarang juga
                </span>
              </div>
              <div class="items-center flex">
                <BButton
                  :variant="profile.is_komads ? 'primary' : 'outline-secondary'"
                  size="sm"
                  class="rounded-lg px-1 w-full sm:w-auto"
                  :disabled="!profile.is_komads"
                  @click="openTopUpModal"
                >
                  <div class="flex items-center justify-center gap-3">
                    <img
                      :src="
                        profile.is_komads
                          ? 'https://storage.googleapis.com/komerce/assets/icons/send-square.svg'
                          : 'https://storage.googleapis.com/komerce/assets/icons/send-square-gray.svg'
                      "
                      alt="send"
                      width="24"
                      height="24"
                    >
                    <span>
                      Top Up
                    </span>
                  </div>
                </BButton>
              </div>
            </div>
          </BCard>
        </BCol>
        <BCol
          cols="12"
          class="border rounded-lg p-1"
        >
          <BCard
            body-class="p-0"
            class="m-0"
          >
            <div class="flex items-center gap-3">
              <img
                src="https://storage.googleapis.com/komerce/assets/LP-Komerce/komcards.svg"
                alt="Komerce"
              >
              <div class="text-black font-medium text-lg">
                Komcards
              </div>
            </div>
            <div class="text-black">
              Gunakan Kompoints-mu sekarang untuk membeli voucher iklan agar
              bisa menghemat biaya bayar iklan!
            </div>
          </BCard>
          <BRow v-if="profile.is_komcards !== 1">
            <BCol cols="12">
              <BAlert
                show
                variant="warning"
                class="p-2"
              >
                <div class="flex flex-row items-center justify-between gap-2">
                  <div>
                    <div class="flex items-center gap-3 mb-[10px]">
                      <img
                        src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg"
                        alt="Komerce"
                      >
                      <h4 class="text-black font-semibold m-0">
                        Kamu belum terdaftar sebagai partner Komcards
                      </h4>
                    </div>
                    <BCardText class="text-[#333333]">
                      Yuk daftar Komcards sekarang juga dan dapatkan cashback
                      untuk membeli voucher!
                    </BCardText>
                  </div>
                  <a
                    href="https://komcards.id/"
                    target="_blank"
                  >
                    <BButton
                      size="sm"
                      variant="outline-warning"
                    >
                      Pelajari lebih lanjut
                    </BButton>
                  </a>
                </div>
              </BAlert>
            </BCol>
          </BRow>
          <BOverlay
            :show="loading.vouchers"
            spinner-variant="primary"
            variant="light"
            blur="0"
            opacity=".5"
            rounded="sm"
          >
            <BRow>
              <BCol
                v-for="item in vouchers"
                :key="item.id"
                cols="12"
                sm="12"
                md="6"
                lg="4"
              >
                <Voucher
                  :voucher="item"
                  :source="'list'"
                  :kompoints="kompoints"
                  @redeemVoucher="redeemVoucher"
                />
              </BCol>
            </BRow>
          </BOverlay>
        </BCol>
      </BRow>
    </div>
    <ModalRedeemVue
      :kompoints="kompoints"
      :voucher="voucher"
      @getVoucherList="getVoucherList"
      @getKompoints="getKompoints"
    />
    <ModalMaxChancePIN />
    <ModalTopupWhitelisted
      :whitelisted-accounts="whitelistedAccounts"
      @topupSuccess="showSuccessTopup"
    />
    <ModalNotRegisteredWhitelisted />
    <ModalSuccessTransaction
      id="modal-success-topup"
      :transaction="transactionDetail"
    />
    <ModalTopupKomedSuccess
      v-model="isShowTopupKomedSuccessModal"
      modal-id="modal-topup-komed-success-voucher"
      :transaction="topupKomedSuccessData"
      @close="closeTopupKomedSuccessModal"
      @download="downloadTopupKomedReceipt"
      @history="navigateToTopupKomedHistory"
    />
    <DrawerTopupKreditKomed
      v-model="isOpenKreditKomedDrawer"
      drawer-id="drawer-topup-kredit-komed-voucher"
      width="460px"
      :balance="kompayBalance"
      :submit-loading="isSubmittingKreditKomedTopup"
      :show-currency-prefix="false"
      @submit="submitKreditKomedTopup"
      @close="closeKreditKomedTopUp"
      @open="getKompayBalance"
      @hidden="closeKreditKomedTopUp"
    />
  </BCard>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { IDR, IDRWithoutLbl } from '@/libs/currency'
import { mapState } from 'vuex'
import ModalMaxChancePIN from '@/views/components/modal/ModalMaxChancePIN.vue'
import ModalRedeemVue from './ModalRedeem.vue'
import ModalTopupWhitelisted from './ModalTopupWhitelisted.vue'
import ModalNotRegisteredWhitelisted from './ModalNotRegisteredWhitelisted.vue'
import ModalSuccessTransaction from './ModalSuccessTransaction.vue'
import Voucher from './Voucher.vue'
import DrawerTopupKreditKomed from '../komed/components/DrawerTopupKreditKomed.vue'
import ModalTopupKomedSuccess from '../komed/components/ModalTopupKomedSuccess.vue'

export default {
  components: {
    DrawerTopupKreditKomed,
    ModalRedeemVue,
    Voucher,
    ModalMaxChancePIN,
    ModalTopupWhitelisted,
    ModalNotRegisteredWhitelisted,
    ModalSuccessTransaction,
    ModalTopupKomedSuccess,
  },
  data() {
    return {
      IDR,
      IDRWithoutLbl,
      loading: {
        kompoints: false,
        vouchers: false,
      },
      kompoints: {},
      vouchers: [],
      voucher: {},
      whitelistedStatus: false,
      whitelistedAccounts: [],
      transactionDetail: null,
      isOpenKreditKomedDrawer: false,
      isShowTopupKomedSuccessModal: false,
      isSubmittingKreditKomedTopup: false,
      topupKomedSuccessData: {
        transactionId: null,
        email: null,
        nominal: 0,
        timestamp: null,
      },
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
    ...mapState('saldo', {
      saldoKompay: 'saldo',
    }),
    ...mapState('auth', {
      authUserData: 'userData',
    }),
    canTopupKomed() {
      return Number(this.profile?.is_komed ?? this.authUserData?.is_komed) === 1
    },
    kompayBalance() {
      return Number(this.saldoKompay || 0)
    },
    userEmail() {
      return this.authUserData?.email || this.profile?.email || ''
    },
    userId() {
      return this.authUserData?.id || this.authUserData?.user_id || this.profile?.id || this.profile?.user_id || null
    },
  },
  mounted() {
    this.getKompoints()
    this.getKompayBalance()
    this.getVoucherList()
    this.getStatusOnboardingWhitelisted()
  },
  methods: {
    async getKompayBalance() {
      await this.$store.dispatch('saldo/getBalanceSummary')
    },
    async getKompoints() {
      this.loading.kompoints = true
      const url = '/auth/api/v1/user/kompoints'
      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.kompoints = data
          this.loading.kompoints = false
        })
        .catch(() => {
          this.loading.kompoints = false
          this.$toast_error({ message: 'Gagal mendapatkan kompoints' })
        })
    },
    async getVoucherList() {
      const url = '/komcards/api/v1/voucher/list'
      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res
          this.vouchers = data.data
          this.loading.vouchers = false
        })
        .catch(() => {
          this.loading.vouchers = false
          this.$toast_error({ message: 'Gagal mendapatkan voucher' })
        })
    },
    async checkVerifyPIN() {
      await newAxiosIns
        .get('/auth/api/v1/user/secured/verify-pin/attempt-left')
        .then(response => {
          const { data } = response.data
          if (data.attempt_left === 0) {
            this.$bvModal.show('max-chance-PIN')
          } else {
            this.$bvModal.show('modal-redeem')
          }
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal cek PIN, silahkan refresh page' })
        })
    },
    redeemVoucher(value) {
      if (this.kompoints.balance < value.kompoint_fee) return this.$toast_error({ message: 'Kompoints tidak cukup' })
      this.voucher = value
      return this.checkVerifyPIN()
    },
    async getStatusOnboardingWhitelisted() {
      await newAxiosIns
        .get('/komads/api/v1/whitelist_accounts/onboarding/status')
        .then(res => {
          const { data } = res
          this.whitelistedStatus = data.data.is_finish
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal mendapatkan status onboarding' })
        })
    },

    async getWhitelistedAccounts() {
      await newAxiosIns
        .get('/komads/api/v1/whitelist_accounts/list')
        .then(res => {
          const { data } = res
          this.whitelistedAccounts = data.data
        })
    },
    openKreditKomedTopUp() {
      this.getKompayBalance()
      this.isOpenKreditKomedDrawer = true
    },
    closeKreditKomedTopUp() {
      this.isOpenKreditKomedDrawer = false
    },
    async submitKreditKomedTopup({ nominal }) {
      if (!this.userEmail) {
        this.$toast_error({ message: 'Email user tidak ditemukan' })
        return
      }

      if (!this.userId) {
        this.$toast_error({ message: 'User ID tidak ditemukan' })
        return
      }

      this.isSubmittingKreditKomedTopup = true
      try {
        const response = await newAxiosIns.post('/komed/api/v1/komed/topup', {
          user_id: this.userId,
          email: this.userEmail,
          nominal,
        })

        const responseData = response?.data?.data || {}

        // Store success data for modal
        this.topupKomedSuccessData = {
          transactionId: responseData.transaction_code,
          email: this.userEmail,
          nominal,
          timestamp: responseData.created_at || new Date().toISOString(),
        }

        this.$toast_success({ message: 'Top up Kredit Komed berhasil' })
        this.closeKreditKomedTopUp()
        this.isShowTopupKomedSuccessModal = true
        await Promise.allSettled([
          this.getKompoints(),
          this.getKompayBalance(),
        ])
      } catch (error) {
        const message = error?.response?.data?.message || 'Top up Komed gagal diproses'
        this.$toast_error({ message })
      } finally {
        this.isSubmittingKreditKomedTopup = false
      }
    },
    closeTopupKomedSuccessModal() {
      this.isShowTopupKomedSuccessModal = false
    },
    downloadTopupKomedReceipt() {
      this.$toast_info({ message: 'Mengunduh bukti transaksi...' })
      // TODO: Implement actual download logic from backend
    },
    navigateToTopupKomedHistory() {
      this.closeTopupKomedSuccessModal()
      this.$router.push({ path: '/komed/keuangan/riwayat-topup' })
    },
    openTopUpModal() {
      // Jika belum terdaftar whitelisted, tampilkan modal not registered
      if (!this.whitelistedStatus) {
        return this.$bvModal.show('modal-not-registered-whitelisted')
      }
      this.getWhitelistedAccounts()
      return this.$bvModal.show('modal-topup-whitelisted')
    },

    async fetchDetailTransaction(id) {
      await newAxiosIns
        .get(`komads/api/v1/whitelist_accounts/transactions/${id}`)
        .then(res => {
          this.transactionDetail = res.data.data
        })
    },
    /**
     * Show success topup modal
     * @param {Object} transactionData - Transaction data to display
     */
    async showSuccessTopup(id) {
      await this.fetchDetailTransaction(id)
      this.$bvModal.show('modal-success-topup')
    },
  },
}
</script>
<style lang="css" scoped>
.alert-warning {
  background: #f8ecc8 !important;
}

</style>
